const ALL_VALUE = 'ALL';

export const AlignmentStatuses = Object.freeze({
  AWAITING_REVIEW: 'AWAITING_REVIEW',
  REQUIRES_NEW_HUDL_VIDEO: 'REQUIRES_NEW_HUDL_VIDEO',
  REQUIRES_RECOLLECTION: 'REQUIRES_RECOLLECTION',
});

export const AlignmentIssuesTypes = Object.freeze({
  LICENSED_VIDEO: 'LICENSED_VIDEO',
  UNLICENSED_VIDEO: 'UNLICENSED_VIDEO',
});

export const AlignmentStatusDropdownValues = Object.freeze({
  ALL: ALL_VALUE,
  ...AlignmentStatuses,
});

export const AlignmentIssueDropdownValues = Object.freeze({
  ALL: ALL_VALUE,
  ...AlignmentIssuesTypes,
});
